var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 203,
    viewBox: "0 0 1030 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.320312 25.6142C0.320312 11.4679 11.7882 0 25.9345 0H936.706C944.545 0 951.953 3.58996 956.811 9.74315L1020.81 90.8089C1025.7 97.0127 1025.7 105.767 1020.81 111.97L956.811 193.036C951.953 199.189 944.546 202.779 936.706 202.779H25.9346C11.7882 202.779 0.320312 191.311 0.320312 177.165V25.6142Z",
    fill: "#ED0677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedEdge);
export default __webpack_public_path__ + "static/media/Curved_Edge.b17a257766e50dcedfe88e922fec204b.svg";
export { ForwardRef as ReactComponent };